export default "__VITE_ASSET__07dce13f__"